const targetDiv = document.querySelector('.section-template--17067381293309__d46f5849-1e62-4ece-91f4-de01d8812cc9-padding');
const body = document.querySelector('.homepage main');
const anotherDiv = document.querySelector('.section-template--17067381293309__02f3bb01-ec38-4828-b085-c139baf6dacf-padding');
const ano = document.querySelector('.section-template--17067381293309__49ba739f-0f4d-4946-9c61-9fe9209ac7f3-padding');

if (targetDiv && body && anotherDiv && ano) {
   let targetDivVisibleHeight = 0.0000000000001 * targetDiv.clientHeight; // Calculate 0.0000000001% of the target div's height 

// Function to update font color to white
function setFontColorToWhite() {
    body.style.color = targetDiv.style.color = anotherDiv.style.color = 'white';
    ano.style.color = 'white';
    body.classList.add("color-white");
}

// Function to update font color to #2f5652
function setFontColorToDefault() {
    body.style.color = targetDiv.style.color = anotherDiv.style.color = '#F2EEE2';
    ano.style.color = '#F2EEE2';
    body.classList.remove("color-white");
}

// Function to update colors based on scroll position
function updateColor() {
  
    const rect = targetDiv.getBoundingClientRect();

    // Calculate the threshold position based on 0.0000000001% of the target div's height
    const offset = rect.height * 0.0000000000001;

    if (rect.top >= -targetDivVisibleHeight) {
        // Section is out of view, change background color to white and font color to #354461
        body.style.backgroundColor = targetDiv.style.backgroundColor = anotherDiv.style.backgroundColor = '#F2EEE2';
        ano.style.backgroundColor = '#F2EEE2';
        setFontColorToDefault();
    } else if (rect.top <= -offset) {
        // Section is scrolled beyond 0.00000000001% of its height, change background color to #2f5652 and font color to white
        body.style.backgroundColor = targetDiv.style.backgroundColor = anotherDiv.style.backgroundColor = '#2f5652';
        ano.style.backgroundColor = '#2f5652';
        setFontColorToWhite();
    }
}

// Add scroll event listener to update color
window.addEventListener('scroll', updateColor);

// Initial call to set initial color
updateColor();
}
